var Tooltip_module_default = {
	tooltip: "_tooltip_1nqnq_8",
	invisible: "_invisible_1nqnq_21",
	caption: "_caption_1nqnq_28",
	arrow: "_arrow_1nqnq_33"
};
//#endregion
export { Tooltip_module_default as default };

//# sourceMappingURL=Tooltip.module.js.map